import * as React from 'react';
import { LoadingProps, Loading } from '../Loading';

export type LoaderProps = LoadingProps & {
    loading: boolean;
    loadingComponent?: JSX.Element;
};

export const Loader: React.FC<LoaderProps> = ({ children, loading, loadingComponent, ...props }) =>
    !loading ? <>{children}</> : loadingComponent ? loadingComponent : <Loading {...props} />;

Loader.displayName = 'Loader';
